
// Live Server
export const environment = {
      production: true,
      // PRO_URL: 'https://businessinmaharashtra.com',
      // API_URL: 'http://localhost:3000/api/',
      // IMG_URL:"http://localhost:3000/backend/upload/",
      // RAZORPAY_KEY_SECRET:"mCNAzSTwrjYdjINm7jmmxNci",
      // RAZORPAY_KEY_ID:"rzp_test_EFdo3obhYt4bpM"

      // production: true,
       PRO_URL: 'https://businessinmaharashtra.com',
       API_URL: 'https://businessinmaharashtra.com/api/',
       IMG_URL:"https://businessinmaharashtra.com/backend/upload/",
      RAZORPAY_KEY_SECRET:"Ji9l5dy6uRRUhLCjAM0NsUpY",
      RAZORPAY_KEY_ID:"rzp_live_ehlAOv5Pn4TULW"

      // Local Testing
      // PRO_URL: 'https://businessinmaharashtra.com/',
      // API_URL: 'https://businessinmaharashtra.com/bim/api/',
      // IMG_URL:"https://businessinmaharashtra.com/bim/backend/upload/",
      // RAZORPAY_KEY_SECRET:"mCNAzSTwrjYdjINm7jmmxNci",
      // RAZORPAY_KEY_ID:"rzp_test_EFdo3obhYt4bpM"
};
